<template>
    <cUtilsEdit @edit="goToHeaderField('pricingSocials')">
        <div class="flex space-x-2">
            <a
                v-for="social in notEmtpySocials"
                :key="social.name"
                :href="social.url"
                @click.prevent="goToLink(social.url)"
                class="pricing-link"
                :style="{ color: pricing.titleColor }"
                target="_blank"
            >
                <span class="sr-only">{{ social.name }}</span>
                <component :is="social.icon" class="h-4 w-4" />
            </a>
        </div>
    </cUtilsEdit>
</template>

<script>
import { markRaw } from "vue";
import {
    FacebookIcon,
    TwitterIcon,
    YoutubeIcon,
    LinkedinIcon,
    InstagramIcon,
    GithubIcon,
    DribbleIcon,
    GlobeIcon,
    TikTokIcon,
} from "@easy/ui/icons";
import { usePricingGoTo } from "@/views/tools/pricing/utils/usePricingGoTo";
import { useGoToLink } from "@/shared/utils/router/useGoToLink";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "SocialsList",
    setup() {
        const { goToLink } = useGoToLink();
        const { goToHeaderField } = usePricingGoTo();
        return {
            goToHeaderField,
            goToLink,
        };
    },
    props: {
        pricing: Object,
    },
    computed: {
        socials() {
            if (!this.pricing.socials) return [];
            return [
                { name: "www", url: this.pricing.socials.wwwUrl, icon: markRaw(GlobeIcon) },
                { name: "fb", url: this.pricing.socials.fbUrl, icon: markRaw(FacebookIcon) },
                {
                    name: "youtube",
                    url: this.pricing.socials.youtubeUrl,
                    icon: markRaw(YoutubeIcon),
                },
                {
                    name: "twitter",
                    url: this.pricing.socials.twitterUrl,
                    icon: markRaw(TwitterIcon),
                },
                {
                    name: "linkedin",
                    url: this.pricing.socials.linkedinUrl,
                    icon: markRaw(LinkedinIcon),
                },
                { name: "ig", url: this.pricing.socials.igUrl, icon: markRaw(InstagramIcon) },
                { name: "gh", url: this.pricing.socials.ghUrl, icon: markRaw(GithubIcon) },
                {
                    name: "dribble",
                    url: this.pricing.socials.dribbleUrl,
                    icon: markRaw(DribbleIcon),
                },
                { name: "tiktok", url: this.pricing.socials.tiktokUrl, icon: markRaw(TikTokIcon) },
            ];
        },
        notEmtpySocials() {
            return this.socials.filter((x) => x.url);
        },
    },
    components: {
        FacebookIcon,
        TwitterIcon,
        YoutubeIcon,
        LinkedinIcon,
        InstagramIcon,
        GithubIcon,
        DribbleIcon,
        GlobeIcon,
        TikTokIcon,
        cUtilsEdit,
    },
};
</script>
